export const createDeleteAutomationForm = token => "marketplaceDeleteAutomationForm" + token;
export const createEditAutomationForm = token => "marketplaceEditAutomationForm" + token;